<a [id]="'application' + template.providerTypeId"></a>
<template #application i2a-container></template>
<template #resources i2a-container></template>